import scrollElementTo from '~/utils/animation/scrollElementTo';

const CLASS_CURRENT = 'current';

function scrollSpy(): ( pageY: number ) => void
{
	const mainItem = document.querySelector(
		'nav.main>ul.menu>li.current>a',
	) as HTMLAnchorElement;
	const descriptionItem = document.querySelector(
		'nav.main>ul.menu>li>a[href="#description"]',
	);
	const descriptionContainer = document.getElementById( 'description' );
	
	if ( !mainItem || !descriptionItem || !descriptionContainer )
	{
		return () => undefined;
	}
	
	let descriptionOffset: number = 0;
	
	const onWindowResize = () =>
		descriptionOffset = descriptionContainer.getBoundingClientRect().top
		+ window.pageYOffset;
	
	window.addEventListener( 'resize', onWindowResize );
	onWindowResize();
	
	let inDescription: boolean = false;
	
	mainItem.addEventListener(
		'click',
		() =>
		{
			if ( inDescription )
			{
				scrollElementTo( window, 0, 500 ).then(
					// tslint:disable-next-line:no-unnecessary-callback-wrapper
					() => updateAddress(),
				);
			}
		},
	);
	
	descriptionItem.addEventListener(
		'click',
		() =>
		{
			scrollElementTo( window, descriptionOffset, 500 );
		},
	);
	
	// tslint:disable-next-line:no-non-null-assertion
	const descriptionItemParent = descriptionItem.parentElement!;
	// tslint:disable-next-line:no-non-null-assertion
	const mainItemmParent = mainItem.parentElement!;
	
	return ( pageY: number ): void =>
	{
		if ( pageY >= descriptionOffset )
		{
			if ( !inDescription )
			{
				inDescription = true;
				descriptionItemParent.classList.add( CLASS_CURRENT );
				mainItemmParent.classList.remove( CLASS_CURRENT );
				mainItem.href = '#';
				updateAddress( 'description' );
			}
		}
		else
		{
			if ( inDescription )
			{
				inDescription = false;
				descriptionItemParent.classList.remove( CLASS_CURRENT );
				mainItemmParent.classList.add( CLASS_CURRENT );
				mainItem.removeAttribute( 'href' );
				updateAddress();
			}
		}
	};
}

/**
 * Обновить адрес в адресной строке.
 * 
 * @param hash Фрагмент страницы.
 */
function updateAddress( hash?: string ): void
{
	window.history.replaceState(
		null,
		document.title,
		( hash ? '/#' + hash : '/' ),
	);
}

/**
 * Module.
 */
export {
	scrollSpy as default,
};



// WEBPACK FOOTER //
// ./app/Common/Scroll/scrollSpy.ts